export default {
      id: "icon-arrowdownred-usage",
      viewBox: "0 0 16 23",
      url: __webpack_public_path__ + "icons.svg#icon-arrowdownred",
      toString: function () {
        return this.url;
      }
    }